import { useContext } from "react";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { Select, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import LineSpacer from "../../../../../../../components/LineSpacer";
import { useAuth } from "../../../../../../../context/AuthContext";
import { useState } from "react";
import { Button } from "antd";
import formatPrice from "../../../../../../../components/formatPrice";
import CommentWithFragments from "../../../../../../../components/CommentWithFragments";

const InitDeduction = (props) => {
	const [open, setOpen] = useState(true);
	const { selectedPerson } = props;
	const { wplyw, setWplyw } = useContext(WplywContext);
	const { user } = useAuth();
	const labelstyle = {
		color: "black",
		fontWeight: "500",
		fontSize: "16px",
		marginBottom: "8px",
	};
	const valuestyle = {
		color: "black",
		fontWeight: "700",
		fontSize: "16px",
	};
	const bigstyle = {
		color: "black",
		fontWeight: "700",
		fontSize: "22px",
	};

	const isGeneratedTransferLocked =
		Boolean(selectedPerson?.msr_persons_transfers_generated_file) ||
		Boolean(selectedPerson?.msr_reserves_generated_file) ||
		Boolean(
			(selectedPerson?.msr_transfers || []).some(
				(t) => t?.msr_transfers_generated_file
			)
		);
	const isDisabled = wplyw.mode === "preview" || isGeneratedTransferLocked;

	const handleInputChange = (e) => {
		setWplyw((prevData) => {
			const updatedPersons =
				prevData.wplyw_data.data.msr_wplywy.msr_persons.map((person) =>
					person.msr_persons_id === selectedPerson.msr_persons_id
						? {
								...person,
								msr_persons_deduction_document: e.target.value,
						  }
						: person
				);

			const changes = [
				...(prevData.changes || []).filter(
					(change) =>
						!(
							change.field === "msr_persons_deduction_document" &&
							change.objectid ===
								selectedPerson.msr_persons_own_id
						)
				),
			];
			changes.push({
				etap: "Odliczenie wstępne",
				field: "msr_persons_deduction_document",
				label: "Zaktualizowano dokument odliczenia",
				action: "edit",
				oldValue: selectedPerson.msr_persons_deduction_document || null,
				newValue: e.target.value,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: selectedPerson.msr_persons_own_id,
				wplywid: prevData.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
			});

			return {
				...prevData,
				wplyw_data: {
					...prevData.wplyw_data,
					data: {
						...prevData.wplyw_data.data,
						msr_wplywy: {
							...prevData.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
				changes,
			};
		});
	};

	const handleTextAreaChange = (e) => {
		setWplyw((prevData) => {
			const updatedPersons =
				prevData.wplyw_data.data.msr_wplywy.msr_persons.map((person) =>
					person.msr_persons_id === selectedPerson.msr_persons_id
						? {
								...person,
								msr_persons_deduction_comment: e.target.value,
						  }
						: person
				);

			const changes = [
				...(prevData.changes || []).filter(
					(change) =>
						!(
							change.field === "msr_persons_deduction_comment" &&
							change.objectid ===
								selectedPerson.msr_persons_own_id
						)
				),
			];
			changes.push({
				etap: "Odliczenie wstępne",
				field: "msr_persons_deduction_comment",
				label: "Zaktualizowano komentarz do odliczenia",
				action: "edit",
				oldValue: selectedPerson.msr_persons_deduction_comment || null,
				newValue: e.target.value,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: selectedPerson.msr_persons_own_id,
				wplywid: prevData.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
			});

			return {
				...prevData,
				wplyw_data: {
					...prevData.wplyw_data,
					data: {
						...prevData.wplyw_data.data,
						msr_wplywy: {
							...prevData.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
				changes,
			};
		});
	};

	return (
		<>
			<div style={{ marginTop: "16px" }}>
				<div
					style={{
						padding: "20px",
						border: "1px solid #BD8136",
						borderRadius: "10px",
						background: "#F9F9F9",
						display: "grid",
						gap: "24px",
					}}
				>
					<div
						style={{
							display: "flex",
							gap: "20px",
							alignItems: "center",
						}}
					>
						<div
							style={{
								background: "black",
								color: "white",
								padding: "7px 15px",
								fontSize: "16px",
								width: "fit-content",
								borderRadius: "5px",
							}}
						>
							#0 Odliczenie wstępne #
							{selectedPerson?.msr_persons_own_id}
						</div>
						<Button onClick={() => setOpen(!open)}>
							{open ? "Zwiń" : "Rozwiń"}
						</Button>
						<LineSpacer></LineSpacer>
					</div>
					<div
						style={{
							display: open ? "grid" : "none",
							gridTemplateColumns:
								"repeat(auto-fit, minmax(150px, 1fr))",
							gap: "32px",
						}}
					>
						<div>
							<div style={labelstyle}>Podział kwoty wpływu</div>
							<div style={valuestyle}>
								{formatPrice(
									selectedPerson?.msr_persons_deduction || 0
								)}{" "}
								zł
							</div>
						</div>
						<div>
							<div style={labelstyle}>Przedmiot kwoty wpływu</div>
							<div style={valuestyle}>Odliczenie wstępne</div>
						</div>
						<div>
							<div style={labelstyle}>Procent odliczenia</div>
							<div style={valuestyle}>100%</div>
						</div>
						<div>
							<div style={labelstyle}>Odliczenie od wpływu</div>
							<div style={valuestyle}>
								{formatPrice(
									selectedPerson?.msr_persons_deduction || 0
								)}{" "}
								zł
							</div>
						</div>
						{/* <div>
                            <div style={labelstyle}>Typ odliczeń</div>
                            <div style={valuestyle}>
                                <Select
                                    style={{ width: "100%" }}
                                    disabled={isDisabled}
                                    defaultValue={wplyw?.wplyw_data?.data?.default_values?.msr_reckonings_types?.[0]?.value || ""}
                                    options={wplyw?.wplyw_data?.data?.default_values?.msr_reckonings_types || []}
                                    value={selectedPerson?.msr_persons_deduction_type}
                                    onChange={handleSelectChange}
                                />
                            </div>
                        </div> */}
						<div>
							<div style={labelstyle}>Numer dokumentu</div>
							<div style={valuestyle}>
								<Input
									disabled={isDisabled}
									value={
										selectedPerson?.msr_persons_deduction_document ||
										""
									}
									onChange={handleInputChange}
								></Input>
							</div>
						</div>
					</div>
					<div
						style={{
							display: open ? "grid" : "none",
							gridTemplateColumns: "1fr 400px",
							gap: "32px",
						}}
					>
						<div>
							<div style={labelstyle}>Uwagi do odliczenia</div>
							<CommentWithFragments
								commentName={"msr_persons_deduction_comment"}
								disabled={isDisabled}
								defaultValue={
									selectedPerson?.msr_persons_deduction_comment ||
									""
								}
								value={
									selectedPerson?.msr_persons_deduction_comment ||
									""
								}
								onChange={handleTextAreaChange}
							/>
						</div>
						<div
							style={{
								borderRadius: "10px",
								background: "white",
								border: "1px solid black",
								padding: "10px",
								display: "flex",
								alignItems: "end",
								justifyContent: "end",
								textAlign: "right",
							}}
						>
							<div>
								<div style={labelstyle}>
									Kwota klienta po rozliczeniu
								</div>
								<div style={bigstyle}>0,00 zł</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default InitDeduction;
